import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MktgComponent } from './mktg.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [MktgComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [MktgComponent]
})
export class MktgModule { }
